import React, { useContext } from "react";
import { AuthContext } from '../../contexts/AuthContext'
import { Col, Row, Button } from "reactstrap";
import Footer from "../../layout/Footer/Footer";
import Header from "../../layout/Header/Header";

function BotonesGastos() {
  const { user } = useContext(AuthContext);
  return (
    <>
          <Header />
          {user.menu_admin ?(
      <div className="container">
        <br />
        <br />

        <Row >
          <Col md={4} align="center">
          {user.menu_gastos ?(
            <Button href="/Categorias" className="botonesMenu" color="success">
              <i class="far fa-list-alt fa-7x"></i>
              <br />
              <br />
              Categorias
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="far fa-list-alt fa-7x"></i>
          <br />
          <br />
          Categorias
        </Button> }
          </Col>
          <Col md={4} align="center">
          {user.menu_gastos ?(
            <Button href="/SubCategorias" className="botonesMenu" color="success">
              <i class="fas fa-list-ol fa-7x"></i>
              <br />
              <br />
              SubCategorias
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-list-ol fa-7x"></i>
          <br />
          <br />
          SubCategorias
        </Button> }
          </Col>
          <Col md={4} align="center">
          {user.menu_gastos ?(
            <Button href="/Solicitantes" className="botonesMenu" color="success">
              <i class="fas fa-user fa-7x"></i>
              <br />
              <br />
              Solicitantes
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-user fa-7x"></i>
          <br />
          <br />
          Solicitantes
        </Button> }
          </Col>
          </Row>
          <br />
          <Row>
          <Col md={4} align="center">
            {user.menu_gastos ?(
            <Button href="/Gastos" className="botonesMenu" color="success">
            <i class="fas fa-receipt fa-7x"></i>
              <br />
              <br />
              Gastos
            </Button>
            ): <Button disabled className="botonesMenu" color="success">
            <i class="fas fa-receipt fa-7x"></i>
              <br />
              <br />
              Gastos
            </Button> }
            </Col>
          <Col md={4} align="center">
            {user.menu_gastos ?(
            <Button href="/GastosRecurrentes" className="botonesMenu" color="success">
            <i class="fas fa-redo-alt fa-7x"></i>
              <br />
              <br />
              Gastos Recurrentes
            </Button>
            ): <Button disabled className="botonesMenu" color="success">
            <i class="fas fa-redo-alt fa-7x"></i>
              <br />
              <br />
              Gastos Recurrentes
            </Button> }
            </Col>
        </Row>
      </div>
      ): undefined } 
      
    </>
  );
}

export default BotonesGastos;
